import { render } from "./detailed.vue?vue&type=template&id=0ebe34f8&scoped=true&ts=true"
import script from "./detailed.vue?vue&type=script&lang=ts"
export * from "./detailed.vue?vue&type=script&lang=ts"

import "./detailed.vue?vue&type=style&index=0&id=0ebe34f8&scoped=true&lang=css"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ebe34f8"]])

export default __exports__